'use client'

import { useLantern } from '~/hooks/use-lantern'
import { ButtonLink } from '~/sotano-kit/primitives/button'
import { FeaturedPost } from '.'

export const PromoBadge = ({
  featuredPost,
}: {
  featuredPost: NonNullable<FeaturedPost>
}) => {
  const { maskRef, elementRef, focusHandlers } = useLantern<
    HTMLSpanElement,
    HTMLAnchorElement
  >({ size: 'sm' })

  return (
    <ButtonLink
      {...focusHandlers}
      ref={elementRef}
      href={`/${
        featuredPost.__typename === 'BlogpostTemplateComponent'
          ? 'blog'
          : 'changelog'
      }/${featuredPost?._slug}`}
      target="_blank"
      rel="noopener noreferer"
      unstyled
      focusStyled
      className="group relative text-dark-faint w-full max-w-max max-h-max flex focus:outline-none focus-visible:outline-none"
    >
      <span
        ref={maskRef}
        style={{ ['--opacity' as string]: 0, opacity: 'var(--opacity)' }}
        aria-hidden
        className="sm:max-w-[440px] overflow-hidden text-ellipsis whitespace-nowrap text-xs font-medium border border-dark-control-base bg-transparent top-0 left-0 z-10 rounded-lg px-[11px] py-1 h-8 flex items-center bg-dark-base w-full absolute"
      >
        <span className="group-hover:underline block text-dark-muted">
          {featuredPost.__typename === 'BlogpostTemplateComponent' ? null : (
            <span className="flex-1">v{featuredPost.version} Release — </span>
          )}

          {featuredPost._title}
        </span>
      </span>

      <span className="sm:max-w-[440px] overflow-hidden text-ellipsis whitespace-nowrap text-xs font-medium border border-dark-border-solid bg-dark-base rounded-lg px-[11px] py-1 h-8 flex items-center w-full">
        <span className="group-hover:underline block text-dark-muted">
          {featuredPost.__typename === 'BlogpostTemplateComponent' ? null : (
            <span className="flex-1">v{featuredPost.version} Release — </span>
          )}

          {featuredPost._title}
        </span>
      </span>
    </ButtonLink>
  )
}
